import { Pencil } from 'lucide-react'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../../components/ui/alert-dialog'
import { Label } from '../../../../../components/ui/label'
import { BasicInput } from '../../../../../components/BasicInput'
import { Textarea } from '../../../../../components/ui/textarea'
import { useEditTeamDetailsController } from './useEditTeamDetailsController'
import { Button } from '@/view/components/ui/button'
import { phoneMask } from '@/app/utils/phoneFormater'

export const EditTeamDetails = () => {
  const { handleEditTeamSubmit, isPending, methods, open, setOpen } =
    useEditTeamDetailsController()

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger>
        <div className="flex h-10 w-12 cursor-pointer items-center justify-center rounded-full border border-gray-300 hover:border-gray-400">
          <Pencil />
        </div>
      </AlertDialogTrigger>
      <AlertDialogContent className="w-[800px] max-w-full overflow-auto p-0">
        <form onSubmit={methods.handleSubmit(handleEditTeamSubmit)}>
          <AlertDialogHeader className="p-5">
            <AlertDialogTitle>Editar equipe</AlertDialogTitle>
          </AlertDialogHeader>
          <div className="border-b-[1px] border-white02" />
          <div className="flex max-h-[780px] flex-col gap-5 overflow-y-auto p-5 lg:flex-row">
            <div className="flex w-full min-w-[320px] flex-col items-center gap-5 pb-0">
              <BasicInput
                label="Nome da equipe"
                name="name"
                placeholder="Nome da equipe"
                style={{ backgroundColor: '#F7F7F7' }}
                error={methods.formState.errors.name?.message}
              />
              <Label htmlFor="about" className="w-full">
                Descrição
                <Textarea
                  {...methods.register('about')}
                  name="about"
                  placeholder="Descrição da equipe"
                  className="mt-2 h-40 w-full resize-none bg-white02"
                />
                {methods.formState.errors.about?.message}
              </Label>
              <BasicInput
                name="supportPhone"
                label="Telefone para Suporte"
                type="text"
                onInput={phoneMask}
                placeholder="(00) 00000-0000"
                style={{ backgroundColor: '#F7F7F7' }}
                error={methods.formState.errors.supportPhone?.message}
              />
            </div>
          </div>

          <AlertDialogFooter className="space-x-2 border-t-[1px] border-white02 p-5 ">
            <AlertDialogCancel className="rounded-full bg-white02">
              Cancelar
            </AlertDialogCancel>
            <Button
              disabled={isPending}
              type="submit"
              className="rounded-full bg-primary font-semibold text-white"
            >
              Salvar alterações
            </Button>
          </AlertDialogFooter>
        </form>
      </AlertDialogContent>
    </AlertDialog>
  )
}
